import { useLayoutEffect, useRef } from "react";
import ContentModalWindow from "./Components/ContentModalWindow";
import { GridLoader } from "../../rcsgrid/createGridTools";

export default function DialogBook({ props, data }) {
  const gridpanelRef = useRef(null);

  useLayoutEffect(() => {
    GridLoader(gridpanelRef.current, props, data);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let content = <ContentModalWindow gridpanelRef={gridpanelRef} props={props} />;

  return <>{content}</>;
}
